import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=252da2ae&scoped=true"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=252da2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252da2ae",
  null
  
)

export default component.exports